// Phase 7 — Call Intelligence label + colour maps.
// Pattern mirrors `frontend/src/pages/Inventory/constants.js`.

export const SENTIMENT_COLORS = {
  positive: 'bg-emerald-100 text-emerald-800',
  neutral:  'bg-slate-100 text-slate-700',
  negative: 'bg-rose-100 text-rose-800',
  mixed:    'bg-amber-100 text-amber-800',
  unknown:  'bg-gray-100 text-gray-700',
};

export const READINESS_COLORS = {
  high:   'bg-emerald-100 text-emerald-800',
  medium: 'bg-amber-100 text-amber-800',
  low:    'bg-rose-100 text-rose-800',
};

export const CONFIDENCE_COLORS = READINESS_COLORS;

export const ANALYSIS_STATUS_COLORS = {
  pending:   'bg-sky-100 text-sky-800',
  completed: 'bg-emerald-100 text-emerald-800',
  failed:    'bg-rose-100 text-rose-800',
  skipped:   'bg-gray-100 text-gray-700',
};

export const OBJECTION_LABELS = {
  price: 'Price',
  payment: 'Payment',
  trade: 'Trade',
  credit: 'Credit',
  timing: 'Timing',
  availability: 'Availability',
  distance: 'Distance',
  spouse_partner: 'Spouse/Partner',
  not_interested: 'Not interested',
  other: 'Other',
};

export const QA_FLAG_LABELS = {
  customer_requested_human: 'Customer asked for human',
  agent_failed_to_offer_callback: 'Missed callback offer',
  agent_claimed_unverified_inventory: 'Unverified inventory claim',
  agent_made_restricted_claim: 'Restricted claim',
  customer_confused: 'Customer confused',
  bad_transfer: 'Bad transfer',
  bad_tool_result: 'Bad tool result',
  possible_dnc_request: 'Possible DNC request',
  other: 'Other',
};

// Filter shortcuts for the existing Call History filter bar.
export const INTELLIGENCE_FILTER_PRESETS = {
  HIGH_INTENT: { min_intent_score: 70 },
  NEEDS_FOLLOWUP: { objection_type: 'timing' },      // approximate
  REQUESTED_HUMAN: { qa_flag: 'customer_requested_human' },
  QA_FLAGGED: { qa_flag: 'any' }, // front-end convenience; map at call site
};
